module.exports = __webpack_public_path__ + "img/logo-supporter-black.2ce5cdc1.png";